import { useEffect, useRef, useState } from "react";
import useAxios from "../../../utils/useAxios";
import { URL } from "../../../libraries/http/url";

interface ISearchPrintingTechnique {
  search?: any;
  id?: string | number;
  limit?: string | number;
}

export const useGetPrintingTechniqueHook = ({
  search,
  id,
  limit,
}: ISearchPrintingTechnique) => {
  const axios = useAxios();
  const [data, setData] = useState<any | any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const abortControllerRef = useRef<AbortController | null>(null);

  const getPrintingTechnique = async ({
    search,
    id,
  }: ISearchPrintingTechnique) => {
    // Abort previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const searchParams = URL.createSearchParams({
      ...search,
      id,
      limit: limit || 50,
    });

    const url = !!id
      ? `/artwork/collection/${id}`
      : `/artwork/printing-technique/?${searchParams.toString()}`;

    try {
      setIsLoading(true);
      const response = await axios.get(url, { signal: controller.signal });

      if (response.status === 200) {
        setData(response.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPrintingTechnique({ search, id });

    return () => {
      // Cleanup on unmount
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [search, id, limit]);

  return { data, isLoading, getPrintingTechnique };
};
